





































































































































































































































































































































































import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import * as RouteNames from "@/employee/route-names";
import Tab from "@/shared/components/ui/Tab.vue";
import TabGroup from "@/shared/components/ui/TabGroup.vue";
import AvidiaForms from "@/employee/components/resources/AvidiaForms.vue";
import AllegacyForms from "@/employee/components/resources/AllegacyForms.vue";
import HsaBankForms from "@/employee/components/resources/HsaBankForms.vue";
import AvidiaFormsInstructions from "@/employee/components/resources/AvidiaFormsInstructions.vue";
import UmbForms from "@/employee/components/resources/UmbForms.vue";
import ElementsForms from "@/employee/components/resources/ElementsForms.vue";
import ElementsFormsInstructions from "@/employee/components/resources/ElementsFormsInstructions.vue";
import UcbForms from "@/employee/components/resources/UcbForms.vue";
import CustomerFormDocuments from "@/employee/components/resources/CustomerFormDocuments.vue";
import TermsFeeSchedule from "@/employee/components/onboarding/TermsFeeSchedule.vue";
import AvidiaTermsFeeSchedule from "@/employee/components/onboarding/AvidiaTermsFeeSchedule.vue";
import AllegacyTermsFeeSchedule from "@/employee/components/onboarding/AllegacyTermsFeeSchedule.vue";
import CombinedStatements from "@/employee/components/landing-pages/hsabank/CombinedStatements.vue";
import TaxDocumentsAllYears from "@/employee/components/landing-pages/hsabank/TaxDocumentsAllYears.vue";
import SecureDocumentUploadComponent from "@/employee/components/landing-pages/SecureDocumentUploadComponent.vue";
import { BankCustodian } from "@/admin/types";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import {
  FormDocumentType,
  HsabSsoDestination,
  ManagedExpenseFilterType,
  TermsTab
} from "@/shared/types";
import ResourcesExternalLinkJumbotrons from "@/employee/components/landing-pages/ResourcesExternalLinkJumbotrons.vue";
import FeeScheduleAndRatesDeepLink from "@/employee/components/landing-pages/hsabank/FeeScheduleAndRatesDeepLink.vue";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { usePartnerPortalStore } from "@/employee/store/partnerPortal";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useUserStore } from "@/shared/store/user";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useCustomerFormDocumentsStore } from "@/employee/store/customerFormDocument";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";

@Component({
  components: {
    Tab,
    TabGroup,
    UmbForms,
    ElementsForms,
    ElementsFormsInstructions,
    UcbForms,
    AvidiaForms,
    AvidiaFormsInstructions,
    AllegacyForms,
    CustomerFormDocuments,
    TermsFeeSchedule,
    AvidiaTermsFeeSchedule,
    HsaBankForms,
    AllegacyTermsFeeSchedule,
    SsoDeepLink,
    GenericLoadingSpinner,
    CombinedStatements,
    TaxDocumentsAllYears,
    SecureDocumentUploadComponent,
    FeeScheduleAndRatesDeepLink,
    ResourcesExternalLinkJumbotrons
  },
})
export default class Resources extends Vue {
  partnerPortalStore = usePartnerPortalStore();
  custodianSettingsStore = useCustodianSettingsStore();
  featureFlagStore = useFeatureFlagStore();
  portalCustomizationStore = usePortalCustomizationStore();
  userStore = useUserStore();
  hsabAccountsStore = useHsabAccountsStore();
  customerFormDocumentStore = useCustomerFormDocumentsStore();
  ManagedExpenseFilterType = ManagedExpenseFilterType;
  FormDocumentType = FormDocumentType;

  @Prop()
  symbol: string;

  @Prop()
  year: number;

  readonly bendTermsAndConditionsFile =
      "bend_financial_terms_of_service 20181009.pdf";

  RouteNames = RouteNames;
  TermsTab = TermsTab;

  get showSecureDocumentUpload (): boolean {
    return (
        this.custodianSettingsStore.userCustodian === BankCustodian.HsaBank &&
        this.featureFlagStore.featureFlagsAvailable &&
        !this.featureFlagStore.flags.bend16780CombinedAccountSummariesEnabled
    );
  }
  get showStatementTab (): boolean {
    return (
        this.custodianSettingsStore.userCustodian === BankCustodian.HsaBank &&
        this.featureFlagStore.featureFlagsAvailable &&
        this.featureFlagStore.flags.bend16780CombinedAccountSummariesEnabled
    );
  }

  get activeTabIndex () {
    return Array.from(this.tabChoiceUrls.keys())
      .findIndex(i => i.params.symbol === this.symbol);
  }

  get tabChoiceUrls () {
    const tabMap = new Map([
      [ { name: RouteNames.Resources, params: { symbol: RouteNames.ResourcesDownloadableFiles } }, "Forms" ]
    ]);
    if (this.showLinksTab) {
      tabMap.set({ name: RouteNames.Resources, params: { symbol: RouteNames.ResourceLinks } }, "Learning Center");
    }
    if (this.showStatementTab) {
      tabMap.set({ name: RouteNames.Resources, params: { symbol: RouteNames.ResourcesDocuments } },
           "Account Summaries");
      if (this.hasHsa) {
        tabMap.set({ name: RouteNames.Resources, params: { symbol: RouteNames.ResourcesTaxForms } },
            "Tax Documents");
      }
      tabMap.set({ name: RouteNames.Resources, params: { symbol: RouteNames.ResourcesSecureDocumentUpload } },
           "Secure Document Upload");
    }
    if (this.custodianSettingsStore.displayFooterLegalSection) {
      tabMap.set({ name: RouteNames.Resources, params: { symbol: RouteNames.ResourcesFees } },
          "Fee & Interest Schedule");
      tabMap.set({ name: RouteNames.Resources, params: { symbol: RouteNames.ResourcesFinancialInstitutionTerms } },
          "Financial Institution Terms");
      tabMap.set({ name: RouteNames.Resources, params: { symbol: RouteNames.ResourcesHsaTerms } }, "HSA Terms");
    }

    return tabMap;
  }

  get hasMultipleTabs (): boolean {
    return this.tabChoiceUrls.size > 1;
  }
  get hasHsa (): boolean {
    return this.hsabAccountsStore.userHasHsaAccount;
  }

  get showAccountSummariesDeepLink (): boolean {
    return this.featureFlagStore.featureFlagsAvailable &&
      !this.featureFlagStore.flags.bend20542RemoveSummariesAndTaxFormDeepLinks;
  }
  get showFeeScheduleAndRates (): boolean {
    return this.hasHsa
      && this.featureFlagStore.featureFlagsAvailable
      && this.featureFlagStore.flags.bend21840ShowFeeScheduleAndRatesDeepLink;
  }

  get showTaxDocumentsDeepLink (): boolean {
    return this.featureFlagStore.featureFlagsAvailable &&
      !this.featureFlagStore.flags.bend20542RemoveSummariesAndTaxFormDeepLinks;
  }

  mounted (): void {
    this.custodianSettingsStore.getCustodianSettings();
    this.partnerPortalStore.getPartnerPortalStatus();
    this.customerFormDocumentStore.loadDocuments();
    this.$on("tab-clicked", (event, tab) => {
      event.preventDefault();
    });
  }

  get hsaStorePartnerLink (): string {
    return "https://hsastore.com/?a_aid=5e2f0892a95de&utm_source=Bend+HSA&utm_medium=TPA+Portal+Proprietary+Link&utm_campaign=TPA+Partner";
  }

  get hsaBluebookLink (): string {
    return "https://www.healthcarebluebook.com/";
  }

  get hasInstructionsWidget (): boolean {
    return (
        this.custodianSettingsStore.displayFaqInstructions &&
        this.custodianSettingsStore.faqInstructionsTemplate.length > 0
    );
  }

  get termsAndConditionsHref () {
    return `/${this.bendTermsAndConditionsFile}`;
  }

  get loadCustomerFormDocumentsFromDatabase (): boolean {
    return this.featureFlagStore.featureFlagsAvailable && this.featureFlagStore.flags.bend16311ResourceFormsInEmployee;
  }

  get showAllegacyDynamicFees (): boolean {
    return (
        this.custodianSettingsStore.userCustodian === BankCustodian.Allegacy &&
        this.featureFlagStore.featureFlagsAvailable &&
        this.featureFlagStore.flags.showDynamicAllegacyFees
    );
  }

  get hsabStatementsDeeplinkLocation () {
    return HsabSsoDestination.Statements;
  }

  get receiptsNeededDeeplinkLocation () {
    return HsabSsoDestination.ReceiptsNeeded;
  }

  get supportPhone (): string {
    return this.portalCustomizationStore.supportInfo.supportPhone;
  }

  get supportPhoneFormatted (): string {
    return `tel:+1-${this.portalCustomizationStore.supportInfo.supportPhone}`;
  }

  get showStopPayment (): boolean {
    return this.custodianSettingsStore.userCustodian === BankCustodian.HsaBank;
  }

  get showClosedAccountsLink (): boolean {
    return this.hsabAccountsStore.userHasAnyInactiveAccount;
  }

  get showUploadClaimReceipts (): boolean {
    return this.featureFlagStore.flags.bend18761AddDeepLinkToResourcesPages
        && this.hsabAccountsStore.userHasActiveNotionalAccounts;
  }
  get showUploadClaimReceiptsActionNeeded (): boolean {
    return this.featureFlagStore.flags.bend16432HsabExpenseManagement
        && this.hsabAccountsStore.userHasActiveNotionalAccounts;
  }
  get hasDocumentLinks (): boolean {
    return this.customerFormDocumentStore.isLoaded && this.customerFormDocumentStore.formDocuments
      .filter(x => x.formDocumentType === FormDocumentType.Link).length > 0;
  }
  get showLinksTab (): boolean {
    return this.featureFlagStore.featureFlagsLoaded
      && this.featureFlagStore.flags.bend19788FormDocumentLinksEnabled
      && this.hasDocumentLinks;
  }
}
